import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { contactsApi } from "@/api/contacts.ts";

interface LogsState {
    user: any | null;
    loading: boolean;
    error: string | null;
}

const initialState: LogsState = {
    user: null,
    loading: false,
    error: null
};

export const fetchUser = createAsyncThunk(
    'logs/fetchUser',
    async (id: number, { getState, rejectWithValue }) => {
        const state = getState() as RootState;
        if (state.logs.user && state.logs.user.id === id) {
            return state.logs.user;
        }
        try {
            const response = await contactsApi.getOne(id);
            return {
                name: response.data,
                id
            }
        } catch (error: any) {
            return rejectWithValue(error.message || 'Ошибка загрузки пользователя');
        }
    }
);

const logsSlice = createSlice({
    name: 'logs',
    initialState,
    reducers: {
        setCurrentUser: (state, action: PayloadAction<any>) => {
            state.user = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUser.fulfilled, (state, action: PayloadAction<any>) => {
                state.user = action.payload;
                state.loading = false;
            })
            .addCase(fetchUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    }
});

export const { setCurrentUser } = logsSlice.actions;
export default logsSlice.reducer;
